import { iconClipboard } from "@kensho/icons";
import { Button, InputGroup } from "@kensho/neo";
import clsx from "clsx";

import { copyToClipboard } from "../utils/copy-text";

interface CopyableValueProps {
  className?: string;
  value: string;
  label?: string;
  description?: string;
}

export function CopyableValue(props: CopyableValueProps) {
  const { className, value, label, description } = props;

  return (
    <div className={clsx("flex items-center gap-3", className)}>
      <InputGroup
        value={value}
        label={label}
        description={description}
        readOnly
      />
      <Button
        aria-label="Copy to clipboard"
        icon={iconClipboard}
        onClick={() => copyToClipboard(value)}
      />
    </div>
  );
}
